import React, { useEffect, useState } from "react";
import CareTeamRow from "./CareTeamRow";
import CareTeamTableMobile from "./CareTeamTableMobile";
import { useDispatch, useSelector } from "react-redux";
import { team } from "redux-store/care-team/care-team.selector";
import { useNavigate } from "react-router-dom";
import { getUserteams } from "redux-store/care-team/care-team.slice";
import { AppDispatch } from "redux-store/store";

const CareTeamTable = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1060);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1060);
  };
  const teams = useSelector(team);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(getUserteams());
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  return (
    <>
      {isMobile ? (
        <>
          {teams?.length !== 0 && teams
            ? teams.map((team, i) => (
                <CareTeamTableMobile
                  key={team._id}
                  hospitalName={team.hospitalName}
                  vetName={team.veterinarianName}
                  email={team.email}
                  _id={team._id}
                />
              ))
            : "No Team Found"}
        </>
      ) : (
        <div className="tw-w-9/10 tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
          <div className="tw-w-9.5/10 tw-mx-auto tw-flex tw-flex-col ">
            {/* 1st item */}
            <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">
                Hospital Name
              </div>
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">
                Veterinarian Name
              </div>
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">
                Email
              </div>
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold"></div>
            </div>
            {/* 2nd item */}
            {teams?.length !== 0 && teams
              ? teams.map((team, i) => (
                  <CareTeamRow
                    hospitalName={team.hospitalName}
                    vetName={team.veterinarianName}
                    email={team.email}
                    _id={team._id}
                  />
                ))
              : "No Vet Found"}
          </div>
        </div>
      )}
    </>
  );
};

export default CareTeamTable;
